// extracted by mini-css-extract-plugin
export var navigation = "mainnav-module--navigation--2L2s2";